export const backToTopButtonLegacyMetaData = {
    mobileOnly: true
}
